import clientLogoImg1 from '../assets/images/client-logo/01.svg';
import clientLogoImg2 from '../assets/images/client-logo/02.svg';
import clientLogoImg3 from '../assets/images/client-logo/03.svg';
import clientLogoImg4 from '../assets/images/client-logo/04.svg';
import clientLogoImg5 from '../assets/images/client-logo/05.svg';
import clientLogoImg6 from '../assets/images/client-logo/06.svg';
import clientLogoImg7 from '../assets/images/client-logo/07.svg';

import awardLogoImg1 from '../assets/images/award-logo/01.svg';
import awardLogoImg2 from '../assets/images/award-logo/02.svg';
import awardLogoImg3 from '../assets/images/award-logo/03.svg';
import awardLogoImg4 from '../assets/images/award-logo/04.svg';
import awardLogoImg5 from '../assets/images/award-logo/05.svg';
import awardLogoImg6 from '../assets/images/award-logo/06.svg';

import clientLogoLight1 from '../assets/images/client-logo/light/01.svg';
import clientLogoLight2 from '../assets/images/client-logo/light/02.svg';
import clientLogoLight3 from '../assets/images/client-logo/light/03.svg';
import clientLogoLight4 from '../assets/images/client-logo/light/04.svg';
import clientLogoLight5 from '../assets/images/client-logo/light/05.svg';
import clientLogoLight6 from '../assets/images/client-logo/light/06.svg';
import clientLogoLight7 from '../assets/images/client-logo/light/07.svg';

const ClientLogoList = [
  { id: 1, imgSrc: clientLogoImg1 },
  { id: 2, imgSrc: clientLogoImg2 },
  { id: 3, imgSrc: clientLogoImg3 },
  { id: 4, imgSrc: clientLogoImg4 },
  { id: 5, imgSrc: clientLogoImg5 },
  { id: 6, imgSrc: clientLogoImg6 },
  { id: 7, imgSrc: clientLogoImg7 },
];

const AwardLogoList = [
  { id: 1, imgSrc: awardLogoImg1 },
  { id: 2, imgSrc: awardLogoImg2 },
  { id: 3, imgSrc: awardLogoImg3 },
  { id: 4, imgSrc: awardLogoImg4 },
  { id: 5, imgSrc: awardLogoImg5 },
  { id: 6, imgSrc: awardLogoImg6 },
];

const ClientLogoList2 = [
  { id: 1, imgSrc: clientLogoLight1 },
  { id: 2, imgSrc: clientLogoLight2 },
  { id: 3, imgSrc: clientLogoLight3 },
  { id: 4, imgSrc: clientLogoLight4 },
  { id: 5, imgSrc: clientLogoLight5 },
  { id: 6, imgSrc: clientLogoLight6 },
  { id: 7, imgSrc: clientLogoLight7 },
];

export default ClientLogoList;
export { AwardLogoList, ClientLogoList2 };
